// Main PDP Section
// $slickGreen = false;
//   function greenSlider() {
//     if ($(window).width() <= 767) {
//         $('.pdp-left-image-row').slick({
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             arrows: false,
//             autoplaySpeed: 2000
//         });
//         $slickGreen = true;
//     } else {
//         if ($slickGreen) {
//             $('.pdp-left-image-row').slick('unslick');
//             $slickGreen = false;
//         }
//     }
//   }
//   $(document).ready(function () {
//     greenSlider();
//   });
//   $(window).on('resize scroll', function () {
//     greenSlider();
//  });

// $('.swatch-element').click(function() {
//  $(".swatch-element").find("label").css("border", "");
//  $(this).find("label").css("border", "1px solid #847f7f");
//   $('.check-stock-msg').removeClass('active');
// if($(".swatch").hasClass("selectsize")){
//   $(this).parent().addClass("selected");
//   $('.swatch').removeClass('selectsize');
//   $('.only_pickup_available ').removeClass('size_not_selected');
//     if($("#PreOrder").prop('checked') == true){
//      $('.add-to-cart .add-to-cart-wishlist').addClass('pre-order-content');
//    }
//   $("#add").val($("#onClickContent").html());
//   $("#pleaseselectsize").css("display", "none");
// }
// if ($(this).attr("onlypickup") == "true") {
//   $(".only_pickup_available").show();
// }else{
//   $(".only_pickup_available").hide();
// }
// if(currentPath === "www.manieredevoir.com"){
// fetch("https://www.manieredevoir.com/variants/"+$(".variants  #variant-listbox").val()+"/?section_id=pickup-availability")
//   .then(response => response.text())
//   .then(text => {
//     const container = document.querySelector('[data-store-availability-container]');
//     document.querySelector('[data-store-availability-container]').innerHTML = "";
//     const pickupAvailabilityHTML = new DOMParser()
//       .parseFromString(text, 'text/html')
//       .querySelector('.shopify-section');
//     container.appendChild(pickupAvailabilityHTML);
//   })
//   .catch(e => {
//   });
// }

  
// // var url = "https://discountapp.manieredevoirtech.com/api/get-available-quantity";
// // var ShopAndVariantID = {shop:"manieredevoiruk.myshopify.com",variant_id:$(".variants  #variant-listbox").val()};
// // $.ajax({ 
// //     type: "GET", 
// //     url: url,
// //     async: false,
// //     dataType: 'json',
// //     data: ShopAndVariantID,
// //     success: function(data) { 
// //     if(data.data.total_quantity >= 1){
// //     jQuery.each( data.data.locations, function( i, val ) {
// //       if(val.name == "Warehouse"){
// //         if(val.available_quantity == 0){
// //           $("#variant-inventory").hide();
// //           $(".only_pickup_available").show();
// //           if ($(".product-page--cart-form form .swatch.size_swatch.clearfix .swatch-element label").length == 1) {
// //             $('.only_pickup_available ').removeClass('size_not_selected');
// //           }
// //           $("#onlypickup").val(true);
// //         }else{
// //           $(".only_pickup_available").hide();
// //           $("#onlypickup").val(false);
// //         }
// //       }
// //     });
// //     }else{
// //       $(".only_pickup_available").hide();
// //       $("#onlypickup").val(false);
// //     }
// //     }, 
// //     error: function(data) { 
// //     } 
// // });
// // if($(".selected.swatch-element").hasClass("soldout")){
// //   var bis_hidden = $('.button_recomndation').attr('data-bis-tag');
// //   if(bis_hidden){
// //     $('.button_recomndation').show();
// //   }else{
// //     $('.button_recomndation, .product_recommendations').hide();
// //     $(".product-page-left-sec").removeClass("recm-view");
// //   }
// // }else{
// //   $('.button_recomndation, .product_recommendations').hide();
// //   $(".product-page-left-sec").removeClass("recm-view");
// // }


  
//   if($(this).hasClass("soldout")){
//   var bis_hidden = $('.button_recomndation').attr('data-bis-tag');
//   if(bis_hidden){
//     $('.button_recomndation').show();
//   }else{
//     $('.button_recomndation, .product_recommendations').hide();
//     $(".product-page-left-sec").removeClass("recm-view");
//   }
// }else{
//   $('.button_recomndation, .product_recommendations').hide();
//   $(".product-page-left-sec").removeClass("recm-view");
// }
// });


if($(window).width() > 767 && $(".product-page--main-content").length > 0){    
  if($(".product-page--main-content .product-page--images-container .main-litght-img:eq(0) video").length > 0){
    $(".product-page--main-content .product-page--images-container .main-litght-img:eq(0) video").get(0).play();
  }
  // var current_img_height = $(".product-page--main-content .product-page--images-container .main-litght-img a img").height();
  var element = document.querySelector(".main-litght-img").children[0].children[0];
  var px_height = window.getComputedStyle(element).height;
  var current_img_height = parseFloat(px_height.replace("px",''));
  $(".product-page--main-content .product-page--images").css('height', (current_img_height - 1) +'px');
}

var $progressBar = $('.main-product-progress');
var slideCount = $(".product-page--main-content .main-litght-img").length;
var firstCalc = 100  / slideCount;
$progressBar.css('background-size', '100%' + firstCalc + '%').attr('aria-valuenow', firstCalc );

$(document).on("click",".main-thumbnail-slider .main-thumbnail-item",function(event){
  var current_select = $(this).index();
  // var singel_slide_height = $(".product-page--images-container .main-litght-img:eq(0)").height();
  var element = document.querySelector(".main-litght-img").children[0].children[0];
  var px_height = window.getComputedStyle(element).height;
  var current_img_height = parseFloat(px_height.replace("px",''));
  $('.product-page--main-content .product-page--images-container').animate({
      'scrollTop' : (current_select * current_img_height) + 2
  },400);
});

// video paly& puse js start here
if($(".product-sec-holder").hasClass("product-video-first")){
  $("#desk-video, #mob-video").addClass("hide")
}else{
  if ($(".product-page-mobile--images-container .main-litght-img-mobile").hasClass("main_html_mp4_video")){
    $("#desk-video, #mob-video").removeClass("hide")
  }
}

$("#desk-video .video-btn, #mob-video .video-btn").click(function(){
    $('[data-href="thumbnail-item-0"]').trigger('click');
    $('.playbutton').trigger('click');
    $('video#prod_video').trigger('play');
});

function videobtn() {
    var thumbnailScroll = $('.main-thumbnail-scroll').width();
    $('#desk-video').css("left", (30 + thumbnailScroll))
 }
 videobtn();
 $(window).on('resize orientationchange', function () {
    videobtn();
 });

$(window).scroll(function () {    
  var scroll = $(window).scrollTop();
  if (scroll >= 25) {
      $("#desk-video.video-btn-wp").addClass("head-sticky");
  } else {
      $("#desk-video.video-btn-wp").removeClass("head-sticky");
  }
  var targetscroll = $(".header-style-one").height();
  if (scroll >= targetscroll ) {
      $("#mob-video.video-btn-wp").addClass("head-sticky");
  } else {
      $("#mob-video.video-btn-wp").removeClass("head-sticky");
  }
});

$(window).on('resize orientationchange', function () {
    if($(window).width() > 767 && $(".product-page--main-content").length > 0){
      // var current_img_height = $(".product-page--main-content .product-page--images-container .main-litght-img a img").height();
      var element = document.querySelector(".main-litght-img");
    var px_height = window.getComputedStyle(element).height;
    var current_img_height = parseFloat(px_height.replace("px",''));
      $(".product-page--main-content .product-page--images").css('height', (current_img_height - 1)+'px');
    }
  });

$(".product-page--main-content .product-page--images-container").scroll(function(){
    var current_val = $(".product-page--main-content .product-page--images-container").scrollTop() + $(".main-wrapper").offset().top;
    var singel_slide_height = $(".product-page--images-container .main-litght-img:eq(0)").height();
    var flag = true;
    var slideCount = $(".product-page--main-content .main-litght-img").length;
    var $progressBar = $('.main-product-progress');
    $(".product-page--images-container .main-litght-img").each(function( index ) {
        // header-key-message
        if($(this).offset().top - $(".header-key-message").innerHeight() <= $(".main-wrapper").offset().top + 27 && $(this).offset().top -$(".header-key-message").innerHeight() + singel_slide_height >= $(".main-wrapper").offset().top + 27 && flag == true){
            $(this).addClass("is-active");
            var current_active = $(this).attr("id");
            $('.main-thumbnail-slider .main-thumbnail-item').removeClass("is-active");
            $('.main-thumbnail-slider .main-thumbnail-item[data-href="'+current_active+'"]').addClass("is-active");
            if($(this).find('.main_html_mp4_video video').length > 0){
              $(this).find('.main_html_mp4_video video').trigger('play');
              setTimeout(function(){
                  if($('[data-href="thumbnail-item-0"]').hasClass('is-active')) {
                    $("#desk-video").addClass("hide")
                  }else if($(".product-sec-holder").hasClass("product-video-first")) {
                     $("#desk-video, #mob-video").addClass("hide")
                  }else{
                    $("#desk-video").removeClass("hide")
                  }
              },50);
            }else{
              $(".product-page--images-container .main-litght-img .main_html_mp4_video video").trigger('pause');
            }
          
            var current_index = $(this).index() + 1;
            var calc = ( (current_index) / (slideCount) ) * 100;
            $progressBar.css('background-size', '100%' + calc + '%').attr('aria-valuenow', calc );
          
            flag = false;
        }else{
            $(this).removeClass("is-active");
        }
    });
});
